module.exports = __webpack_public_path__ + "img/state-wpay.a67f945c.png";